<template>
  <div class="pages">
    <div class="content" :class="userInfo.is_sub == 0?'content1':''" >
      <div class="logoTitle">
        <img src="../../assets/img/2234.svg" alt class="logoLogin" ondragstart="return false;" />
        
      </div>

      <div v-if="userInfo">

        <div v-if="userInfo.is_expire == 0" class="tabItem uploadBg" @click="goupLoad">
          <!-- <img src="../../assets/img/shangchuanIcon.svg" alt /> -->
          <img src="../../assets/img/c3.svg" alt class="icon"/>
          <span>超爽整理工具</span>
        </div>

        <div v-if="userInfo.is_expire == 1 && userInfo.is_download == 1" class="tabItem uploadBg" @click="goupLoad">
          <!-- <img src="../../assets/img/shangchuanIcon.svg" alt /> -->
          <img src="../../assets/img/download-all.svg" alt class="icon"/>
          <span>一次性下载全部内容</span>
        </div>

        <!-- 管理员才能支付 -->
        <div  v-if="userInfo.is_sub == 0" class="tabItem uploadBg"  @click="goPay">
          <!-- <img src="../../assets/img/shangchuanIcon.svg" alt /> -->
          <img src="../../assets/img/cv-time.svg" alt class="icon"/>
          <span>续期或升级</span>
        </div>

      </div>
      <!-- <div class="tabItem jiaofuBg" @click="goDelivery">
        <img src="../../assets/img/jiaofuIcon.svg" alt />
        <span>交付助手</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  userInfo,
} from "@/request/api";

export default {
  name: "tab",
  data() {
    return {
      userInfo: null,
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    goDelivery() {
      this.$router.push({
        path: "/userHome"
      });
    },
    goupLoad() {
      this.$router.push({
        path: "/transferView"
      });
    },
    getUserInfo() {
      var that = this;
      userInfo().then(res => {
        console.log(res, "个人信息？");
        that.userInfo = res.data.data;
      });
    },
    goPay()
    {
      this.$router.push({
        path: "/pay"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.pages {
  width: 100vw;
  height: 100vh;
  background-image: url(../../assets/img/loginBack.jpg);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 330px;
    // height: 440px;
    height: 280px;
    // margin-top: -40px;
    border-radius: 10px;
    background: #ffffff;
    text-align: center;
    box-shadow: 3px 3px 11px 0px rgba(182, 182, 182, 0.14);
    position: relative;
    z-index: 20;
    .logoTitle {
      margin: 32px auto 50px;
      // margin: 32px auto 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      .logoLogin {
        height: 35px;
        display: inline-block;
        vertical-align: middle;
      }

      .shuxian {
        font-size: 16px;
        margin: 0px 10px;
      }

      .titleType {
        font-size: 18px;
      }
    }


    .tabItem {
      width: 286px;
      height: 96px;
      margin: 18px auto 0px;
      line-height: 96px;
      cursor: pointer;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon{
        width: 30px;
      }
      img {
        margin-right: 10px;

      }
      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-top: 0px !important;
      }
    }
    .uploadBg {
      // background: url(../../assets/img/uploadBg.svg);
      // background-size: cover;
      background: rgba(0,0,0,0.05);
    }

    .uploadBg:hover{
      background: rgba(0,0,0,0.1);

    }
    
    .jiaofuBg {
      background: url(../../assets/img/jiaofuBg.svg);
      background-size: cover;
    }
  }

  .content1{
    height: 400px;
  }
}
</style>